import { useApiGet } from "./Api.hooks";

const endpoint = `/api/reworks`;

export const useGetReworksFromLastSixWeeks = () => {
  return useApiGet(`${endpoint}/last-six-weeks`);
};
